/** The opening form (#5786). */
export interface FundOpeningFormModel {
  amount: number;
  movementDate: Date | null;
  bankAccount: string | null;
  bankingReference: string | null;
  bankingFee: number | null;
  securityFee: number | null;
  note: string | null;
}

export const fundOpeningFieldLabels: Record<keyof FundOpeningFormModel, string> = {
  amount: 'FundOpening_Field_Amount',
  movementDate: 'FundOpening_Field_Date',
  bankAccount: 'BankCharges_BankAccount',
  bankingReference: 'BankCharges_Reference',
  bankingFee: 'BankCharges_BankingFee',
  securityFee: 'BankCharges_SecurityFee',
  note: 'FundOpening_Field_Note',
};
